goog.provide("shadow.js.shim.module$$tiptap$extension_superscript");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_superscript");
shadow.js.shim.module$$tiptap$extension_superscript = shadow.js.nativeProvides["@tiptap/extension-superscript"] = shadow$bridge("@tiptap/extension-superscript");
module$shadow_js_shim_module$$tiptap$extension_superscript.default = shadow.js.shim.module$$tiptap$extension_superscript;
